<template>
    <vx-selectable v-model="model"
        placeholder="Search"
        :loading="loading"
        :options="response"
        :clearable="props.clearable"
        label="name"
        value="id"
        @search="search"
        data-test="org-unit-selectable">
    </vx-selectable>
</template>

<script setup>
import { VxSelectable } from '@voxie/frontend-components';
import { onUnmounted } from 'vue';
import { orgUnitsClient } from '~/services';
import { useSearchRequest } from '~/composables/useSearchRequest';

const props = defineProps({
    clearable: {
        type: Boolean,
        default: true,
    },
});

const teamId = Spark.state.currentTeam.id;
const model = defineModel();

const {
    loading,
    response,
    createSearch,
    cancelSearch,
    cancelKey,
} = useSearchRequest(orgUnitsClient);

const search = createSearch(async (query) => {
    const { data } = await orgUnitsClient.listOrgUnits(teamId, {
        query: query,
    }, {
        cancelKey: cancelKey,
    });

    return data.data.map((orgUnit) => ({
        id: orgUnit.id,
        name: orgUnit.name
    }));
});

// Initialize with empty search
search();

// Clean up on component unmount
onUnmounted(() => {
    cancelSearch();
});
</script>
